import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-675a2558"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page-title pt-4" }, "Associer une catégorie URSSAF à une collection subventionnable", -1))

import CustomButton from "@/components/forms/CustomButton.vue";
import { EditSocialEventGrantCollection } from "../../variantProductCollection";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageMappingGrantCollectionCategoryUrssafEditionDetail',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomButton, {
      to: {
            name: 'listVariantProductCollection'
        },
      label: "Links.goBack"
    }),
    _hoisted_1,
    _createVNode(_unref(EditSocialEventGrantCollection))
  ], 64))
}
}

})